// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-modal {
  @media (max-width: 768px) {
    right: 0 !important;
  }
}

.ant-modal-content {
  width: 100%;
}

.ant-modal-confirm-title {
  padding: 20px;
}

.modal-title {
  display: flex;
  justify-content: center;
  align-items: center; 
}

.ant-modal-confirm-body {
  position: relative;
  span[role="img"] {
    position: absolute;
    right: 0;
    margin-left: auto;
    color: #286ce2 !important;
  }
}

.ant-modal-confirm-body > .anticon + .ant-modal-confirm-title + .ant-modal-confirm-content {
  margin: 0;
}

.modal-content-text {
  font-family: Elevance Sans;
  font-weight: 600;
  font-size: 24px;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: center;
}

.ant-modal-confirm-btns {
  display: none;
}`, "",{"version":3,"sources":["webpack://./client/components/ErrorModal/ErrorModal.css"],"names":[],"mappings":"AAAA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB;IACE,kBAAkB;IAClB,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;EAC3B;AACF;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".ant-modal {\n  @media (max-width: 768px) {\n    right: 0 !important;\n  }\n}\n\n.ant-modal-content {\n  width: 100%;\n}\n\n.ant-modal-confirm-title {\n  padding: 20px;\n}\n\n.modal-title {\n  display: flex;\n  justify-content: center;\n  align-items: center; \n}\n\n.ant-modal-confirm-body {\n  position: relative;\n  span[role=\"img\"] {\n    position: absolute;\n    right: 0;\n    margin-left: auto;\n    color: #286ce2 !important;\n  }\n}\n\n.ant-modal-confirm-body > .anticon + .ant-modal-confirm-title + .ant-modal-confirm-content {\n  margin: 0;\n}\n\n.modal-content-text {\n  font-family: Elevance Sans;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 22px;\n  letter-spacing: 0px;\n  text-align: center;\n}\n\n.ant-modal-confirm-btns {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
